/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { ICON_PERSON } from '../../Icons';
import { Avatar, AvatarProps } from '../Avatar';
import { SdsIcon } from '../SdsIcon';
import { UserProps, userDefaults } from './User.props';

/**
 * SDS User component.
 */
export const User = (props: UserProps): JSX.Element => {
  const { avatarSize, classes, displayAvatar, hideName, hidePhoto, hideSurname, user, ...rest } = {
    ...userDefaults,
    ...props,
  };
  const userClass = clsx(`sds-user`, classes);
  const userName = clsx(user.firstName, {
    [user.lastName]: !hideSurname,
  });

  const avatarClass = clsx(`sds-avatar`, `size--${avatarSize}`, classes);

  const avatarUserInfo = { ...user };

  if (hidePhoto) {
    delete avatarUserInfo.photo;
  }

  const avatarProps: AvatarProps = {
    avatarSize,
    user: avatarUserInfo,
  };

  // Attempt tooltip inclusion for long names

  return (
    <div className={userClass} {...rest}>
      {displayAvatar && (
        <div className="sds-user-avatar">
          {avatarUserInfo.photo ? (
            <Avatar {...avatarProps} />
          ) : (
            <div className={avatarClass}>
              <div className="sds-avatar-icon">
                <SdsIcon svg={ICON_PERSON} />
              </div>
            </div>
          )}
        </div>
      )}
      {!hideName && <span className="sds-user-name">{userName}</span>}
    </div>
  );
};
